import React, {Component} from "react";
import { connect } from 'react-redux';
import {Route} from "react-router";
import {history} from "../../helpers/history";
import PanelNavbar from "./_inc/Navbar/PanelNavbar";
import PanelSidebar from "./_inc/Sidebar/PanelSidebar";
import {panelActions} from "../../actions/panel.actions";
import DashboardPage from "./Dashboard/DashboardPage";
import NetworkDevicePage from "./NetworkDevice/NetworkDevicePage";
import ModalContainer from "../../components/ModalContainer";
import NetworkDeviceCreatePage from "./NetworkDevice/NetworkDeviceCreatePage";
import NetworkDeviceEditPage from "./NetworkDevice/NetworkDeviceEditPage";
import NetworkDeviceContentPage from "./NetworkDeviceContent/NetworkDeviceContentPage";
import NetworkDeviceContentCreatePage from "./NetworkDeviceContent/NetworkDeviceContentCreatePage";
import NetworkDeviceContentEditPage from "./NetworkDeviceContent/NetworkDeviceContentEditPage";
import DeviceGroupPage from "./DeviceGroup/DeviceGroupPage";
import DeviceGroupSchedulePage from "./DeviceGroupSchedule/DeviceGroupSchedulePage";
import DeviceTypePage from "./DeviceType/DeviceTypePage";
import SettingPage from "./Setting/SettingPage";
import UserPage from "./User/UserPage";
import RolePage from "./Role/RolePage";
import RoleEditPage from "./Role/RoleEditPage";
import RoleCreatePage from "./Role/RoleCreatePage";
import UserProfilePage from "./User/UserProfilePage";
import DaliHelvarGroupPage from "./NetworkDeviceDali/Helvar/DaliHelvarGroupPage";
import DaliHelvarScenePage from "./NetworkDeviceDali/Helvar/DaliHelvarScenePage";
import AuthRoute from "../../components/AuthRoute";
import ExhibitionMapPage from "./ExhibitionMap/ExhibitionMapPage";
import NetworkDeviceMonitorPage from "./NetworkDevice/NetworkDeviceMonitorPage";
import ExhibitionMapConfigPage from "./ExhibitionMap/ExhibitionMapConfigPage";
import DaliHelvarAreaPage from "./NetworkDeviceDali/Helvar/DaliHelvarAreaPage";
import AutomationPage from "./Automation/AutomationPage";
import DaliEsSystemAreaPage from "./NetworkDeviceDali/EsSystem/DaliEsSystemAreaPage";
import DaliEsSystemGroupPage from "./NetworkDeviceDali/EsSystem/DaliEsSystemGroupPage";
import DaliEsSystemScenePage from "./NetworkDeviceDali/EsSystem/DaliEsSystemScenePage";
import NetworkDeviceContentActivityPage from "./NetworkDeviceContent/NetworkDeviceContentActivityPage";
import NetworkDeviceLogsPage from "./NetworkDevice/NetworkDeviceLogsPage";
import {Link} from "react-router-dom";
import LogPage from "./Log/LogPage";
import ExhibitionScenarioPage from "./ExhibitionScenario/ExhibitionScenarioPage";
import {userHelper} from "../../helpers/user-helper";
import NotificationPage from "./Notification/NotificationPage";
import NodeRedUI from "./NodeRedUI/NodeRedUI";
import DmxPxmScenePage from "./NetworkDeviceDxm/PXM/DmxPxmScenePage";
import NetworkResetDevicePage from "./NetworkResetDevice/NetworkResetDevicePage";
import NetworkResetDeviceCreatePage from "./NetworkResetDevice/NetworkResetDeviceCreatePage";
import NetworkResetDeviceEditPage from "./NetworkResetDevice/NetworkResetDeviceEditPage";
import ActivityLogsPage from "./ActivityLogs/ActivityLogsPage";
import ImportsPage from "./Imports/ImportsPage";
import ImportNetworkDevice from "./Imports/ImportNetworkDevice";

class PanelPage extends Component {

    timeout;

    state = {
        collapse: localStorage.getItem('sidebar-mode') ? localStorage.getItem('sidebar-mode') : 'full'
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(panelActions.getMenu());
        document.addEventListener('click', this.handleClickGlobal);
        this.timeout = setInterval(this.timerLogout, 1000);
    }

    changeLogo = (collapseState) => {
        this.setState({
            collapse: collapseState
        })
    };

    timerLogout = () => {
        let dateNow = new Date();
        if(localStorage.getItem('expirationToken') && parseInt(localStorage.getItem('expirationToken')) < dateNow.getTime() )
        {
            history.push('/login');
            clearInterval(this.timeout);
        }
    };

    handleClickGlobal = (e) => {
        // TODO MAKE CONFIG PROP FROM MINUTES
        const expirationToken = new Date().getTime() + (30 * 60000);
        localStorage.setItem('expirationToken', expirationToken.toString());
    };

    render() {
        const { menu, user } = this.props;

        const src = this.state.collapse === 'full' ? "/assets/logo.png" : '/assets/logo-sm.png';
        const useScenario = userHelper.getUseExhibitionScenario(user);

        return(
            <React.Fragment>

                <div className="wrapper">
                    <PanelNavbar changeStorage={(mode) => { this.changeLogo(mode) }} />
                    <aside className="main-sidebar sidebar-dark-primary elevation-4">
                        <Link to={'/panel'} className="brand-link">
                            <img src={src} alt="log" className="d-block m-auto pt-3"/>
                        </Link>

                        <div className="sidebar">
                            <PanelSidebar menus={menu}/>
                        </div>
                    </aside>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="pt-3">

                                    <Route exact path="/panel" component={DashboardPage} />
                                    {/*NETWORK DEVICE*/}
                                    <AuthRoute claim="network-device" exact path="/panel/network-device" component={NetworkDevicePage} />
                                    <AuthRoute claim="network-device" exact path="/panel/network-device/create" component={NetworkDeviceCreatePage} />
                                    <AuthRoute claim="network-device" exact path="/panel/network-device/edit/:id" component={NetworkDeviceEditPage} />
                                    <AuthRoute claim="network-device" exact path="/panel/network-device/monitor/:id" component={NetworkDeviceMonitorPage} />
                                    <AuthRoute claim="network-device" excat path="/panel/network-device/logs/:id" component={NetworkDeviceLogsPage} />

                                    {/*NETWORK DEVICE CONFIG DALI HELVAR*/}
                                    {/*todo: permission from dali configurations*/}
                                    <AuthRoute claim="network-device-content" excat path='/panel/network-device/dali/helvar/:id/area' component={DaliHelvarAreaPage} />
                                    <AuthRoute claim="network-device-content" exact path='/panel/network-device/dali/helvar/:id/groups/:areaId' component={DaliHelvarGroupPage} />
                                    <AuthRoute claim="network-device-content" exact path='/panel/network-device/dali/helvar/:id/scenes/:areaId/:groupId' component={DaliHelvarScenePage} />

                                    {/*NETWORK DEVICE CONFIG DALI ES-SYSTEM*/}
                                    {/*todo: permission from dali configurations*/}
                                    <AuthRoute claim="network-device-content" excat path='/panel/network-device/dali/es-system/:id/area' component={DaliEsSystemAreaPage} />
                                    <AuthRoute claim="network-device-content" exact path='/panel/network-device/dali/es-system/:id/groups/:areaId' component={DaliEsSystemGroupPage} />
                                    <AuthRoute claim="network-device-content" exact path='/panel/network-device/dali/es-system/:id/scenes/:areaId/:groupId' component={DaliEsSystemScenePage} />

                                    {/*NETWORK DEVICE CONFIG DXM MODBUS*/}
                                    <AuthRoute claim="network-device-content" exact path="/panel/network-device/dmx/pxm/:id/scenes" component={DmxPxmScenePage} />

                                    <AuthRoute claim="network-device-content" exact path="/panel/network-device/content/:id" component={NetworkDeviceContentPage} />
                                    <AuthRoute claim="network-device-content" exact path="/panel/network-device/content/:id/logs" component={NetworkDeviceContentActivityPage} />
                                    <AuthRoute claim="network-device-content.actions.crud" exact path="/panel/network-device/content/:id/create" component={NetworkDeviceContentCreatePage} />
                                    <AuthRoute claim="network-device-content.actions.crud" excat path='/panel/network-device/content/:id/edit/:contentId' component={NetworkDeviceContentEditPage} />

                                    <AuthRoute claim="map" exact path='/panel/exhibition-map' component={ExhibitionMapPage} />
                                    <AuthRoute cailm="map.actions.crud" excat path='/panel/exhibition-map/config' component={ExhibitionMapConfigPage} />
                                    {/*DEVICE GROUPS*/}
                                    <AuthRoute claim="device-group" exact path='/panel/device-group' component={DeviceGroupPage} />
                                    <AuthRoute claim="schedule" exact path='/panel/device-group/:id/schedule' component={DeviceGroupSchedulePage} />
                                    {/*DEVICE TYPES*/}
                                    <AuthRoute claim="device-type" exact path='/panel/device-type' component={DeviceTypePage} />
                                    {/*SETTINGS*/}
                                    <AuthRoute claim="settings" exact path='/panel/settings' component={SettingPage} />
                                    {/*USERS*/}
                                    <AuthRoute claim="users" exact path='/panel/user' component={UserPage} />
                                    <AuthRoute claim="users.actions.crud" exact path='/panel/user/profile' component={UserProfilePage} />
                                    {/*ROLES*/}
                                    <AuthRoute claim="roles" exact path='/panel/role' component={RolePage} />
                                    <AuthRoute claim="roles" exact path='/panel/role/create' component={RoleCreatePage} />
                                    <AuthRoute claim="roles" exact path='/panel/role/edit/:id' component={RoleEditPage} />
                                    {/*automation*/}
                                    <AuthRoute claim="roles" exact path="/panel/automation" component={AutomationPage} />
                                    {/*Node Red UI */}
                                    <AuthRoute claim="dashboard" exact path="/panel/dashboard-ui" component={NodeRedUI}/>
                                    {/*exhibition scenario*/}
                                    <AuthRoute globalClaim={useScenario} claim="exhibition-scenario" exact path="/panel/exhibition-scenario" component={ExhibitionScenarioPage} />
                                    {/*logs*/}
                                    {/*<AuthRoute claim={"logs"} exact path="/panel/log" component={LogPage}/>*/}
                                    <AuthRoute claim="other" exact path="/panel/notifications" component={NotificationPage}/>
                                    {/* resetator */}
                                    <AuthRoute claim="network-device" exact path="/panel/network-reset-device" component={NetworkResetDevicePage} />
                                    <AuthRoute claim="network-device" exact path="/panel/network-reset-device/create" component={NetworkResetDeviceCreatePage} />
                                    <AuthRoute claim="network-device" exact path="/panel/network-reset-device/edit/:id" component={NetworkResetDeviceEditPage} />
                                    {/*activity logs */}
                                    <AuthRoute claim="other" exact path="/panel/activity-logs" component={ActivityLogsPage} />
                                    <AuthRoute claim="other" excat path="/panel/imports" component={ImportsPage} />
                                    <AuthRoute claim="other" excat path="/panel/import/network-device" component={ImportNetworkDevice} />
                                </div>
                            </div>
                        </section>
                    <ModalContainer />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    const { menu } = state.panelReducer;
    return {
        user,
        menu
    }
};

export default connect(mapStateToProps)(PanelPage)
